import FlexBox from '@/atomic-components/FlexBox';
import LencoButton from '@/atomic-components/LencoButton';
import { Box, Skeleton } from '@mui/material';

const LineItemShimmer = () => (
	<FlexBox justifyContent={'space-between'} mb='16px'>
		<FlexBox width='60%'>
			<Skeleton
				sx={{ width: '24px', height: '24px', mr: '8px' }}
				variant='circular'
			></Skeleton>
			<Skeleton sx={{ width: '70%' }}></Skeleton>
		</FlexBox>
		<Skeleton sx={{ width: '30%' }}></Skeleton>
	</FlexBox>
);

const CartSummaryShimmer = () => {
	return (
		<Box
			p='25px'
			sx={{
				background: 'white',
				borderRadius: '8px',
				boxShadow: '0px 8px 16px rgba(34, 34, 34, 0.1)',
			}}
		>
			<LineItemShimmer />
			<LineItemShimmer />
			<LencoButton disabled fullWidth variant='contained'>
				<FlexBox fullWidth justifyContent={'space-between'}>
					<Skeleton height={26} width={'30%'} />
					<Skeleton height={26} width={'50%'} />
				</FlexBox>
			</LencoButton>
		</Box>
	);
};

export default CartSummaryShimmer;
